import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.flightCompanyEditPage || initialState;

export const selectFlightCompanyData = createSelector(
    [selectDomain],
    state => state.flightCompanyData,
);

export const selectLoading = createSelector(
    [selectDomain],
    state => state.loading,
);
